export default "__VITE_ASSET__BgwNKwpg__"